// Portal configuration
export interface AppConfig {
  authApiUrl: string;
  portalApiUrl: string;
  contractLensUrl: string;
  contractLensApiUrl: string;
  appName: string;
  version: string;
}

// Default configuration - can be overridden by environment
const config: AppConfig = {
  // Auth.Api is served at the ROOT of api.lynki.no. An /auth path prefix 404s, which
  // silently fails every session check and loops the user back to the login screen.
  // Verified against the running server, not assumed.
  authApiUrl: import.meta.env.VITE_AUTH_API_URL || 'https://api.lynki.no',
  portalApiUrl: import.meta.env.VITE_PORTAL_API_URL || 'https://api.lynki.no',
  contractLensUrl: import.meta.env.VITE_CONTRACTLENS_URL || 'https://contractlens.lynki.no',
  contractLensApiUrl: import.meta.env.VITE_CONTRACTLENS_API_URL || 'https://contractlens.lynki.no',
  appName: 'Lynki Portal',
  version: '1.0.0',
};

export default config;

// Product configuration for embedded apps
export interface ProductConfig {
  id: string;
  name: string;
  route: string;
  embedUrl?: string;
  isEmbedded: boolean;
  icon: string;
}

export const products: ProductConfig[] = [
  {
    id: 'contractlens',
    name: 'ContractLens',
    route: '/products/contractlens',
    embedUrl: config.contractLensUrl,
    isEmbedded: true,
    icon: 'file-text',
  },
  // Add more products here as they become available
];
